import { request } from '@/utils/request'
const ReportService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 获取报表类型
     */
    GetReportClassSelectionRange({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/GetReportClassSelectionRange', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     *  获取可用于报表展示的属性清单
     */
    GetPropertySelectionRange({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/GetPropertySelectionRange', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 存储报表信息
     */
    SaveReportInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/api/report/v2/SaveReportInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 	删除报表信息
     */
    DeleteReportInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/DeleteReportInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 报表信息分页查询-已接入用户权限
     */
    GetReportInfoList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/GetReportInfoList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 	获取报表信息
     */
    GetReportInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/GetReportInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetReports({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/report/v2/GetReports', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Get_MainMeterNameList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/Get_MainMeterNameList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Get_MainMeterRecordsList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/Get_MainMeterRecordsList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Delete_MainMeterRecords({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/Delete_MainMeterRecords', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    BatchSave_MainMeterRecords({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/BatchSave_MainMeterRecords', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Save_MainMeterRecords({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/Save_MainMeterRecords', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DownCustomReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.exportDataGet('/api/report/v2/ExportProjectReport', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    FangAnBaoGao_ToExcel({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.exportDataGet('/api/equipment/v1/FangAnBaoGao_ToExcel', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
export default ReportService
